export enum Order {
    DATE = 'date',
    MOST_VIEWED = 'most-viewed'
}

export const TYPES_CVE_LIST_PAGE_SIZE = 50;
export const TYPES_CVE_MOST_VIEWED_LIMIT = 5_000;
